// @flow

import actionCreators from "@modules/reporting/actionCreator";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import { GetEmployeeDetails } from "@modules/reporting/constants/actions";
import http from "@http";
import config from "@config";

type EmployeeRequest = $Exact<{
  clientId: number,
  employeeId: number,
}>;

export function* onGetEmployeeDetails({ payload }: Action<EmployeeRequest>): Generator<*, void, *> {
  try {
    if (!payload || !payload.clientId || !payload.employeeId) {
      throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
    }

    const response = yield call(
      http.get,
      `/api/v1/employee-admin/client/${payload.clientId}/employee/${payload.employeeId}`,
    );

    yield put(actionCreators.GetEmployeeDetailsSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetEmployeeDetailsError(e.response));
  }
}

export function* EmployeeDetailsSaga(): Generator<*, void, void> {
  yield all([takeEvery(GetEmployeeDetails, onGetEmployeeDetails)]);
}

export default EmployeeDetailsSaga;
